import React from 'react';
import MainInfoTracLayout from '../../components/Layout/Main';
import Content from '../../components/Pages/MessageManager';
import { displayName } from '../../../App';

function MessageManager() {
  document.title = `${displayName}: Message Manager`;

  return (
    <MainInfoTracLayout>
      <Content />
    </MainInfoTracLayout>
  );
}

export default MessageManager;
